module.exports = __webpack_public_path__ + "img/540.5396c5ae.png";